import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PageWidth } from "./components/travel-ui";
import { useMemberAuth } from "./auth/MemberAuthContext";
import { useWallet } from "./services/wallet.service";

export default function MemberProfile() {
  const { logout } = useMemberAuth();
  const navigate = useNavigate();
  const wallet = useWallet();

  return (
    <PageWidth className="max-w-2xl">
      <h1 className="text-2xl font-bold">Account</h1>
      <div className="mt-4 rounded-lg border border-[#e7e7e7] bg-white p-5">
        <p className="text-lg font-bold">{wallet.fullName || "Member"}</p>
        <p className="text-sm text-[#595959]">
          {wallet.tierName}
          {wallet.enrollmentDate ? ` · Member since ${wallet.enrollmentDate}` : ""}
        </p>
        <dl className="mt-4 space-y-2 text-sm">
          <div className="flex justify-between gap-4">
            <dt className="text-[#595959]">Email</dt>
            <dd>{wallet.email || "—"}</dd>
          </div>
          <div className="flex justify-between gap-4">
            <dt className="text-[#595959]">Mobile</dt>
            <dd>{wallet.mobile || "—"}</dd>
          </div>
          <div className="flex justify-between gap-4">
            <dt className="text-[#595959]">Member ID</dt>
            <dd>{wallet.memberId || "—"}</dd>
          </div>
          <div className="flex justify-between gap-4">
            <dt className="text-[#595959]">Available points</dt>
            <dd>{wallet.points.toLocaleString("en-IN")}</dd>
          </div>
          {wallet.pendingPoints > 0 ? (
            <div className="flex justify-between gap-4">
              <dt className="text-[#595959]">Pending points</dt>
              <dd>{wallet.pendingPoints.toLocaleString("en-IN")}</dd>
            </div>
          ) : null}
          {wallet.benefits.length ? (
            <div className="flex justify-between gap-4">
              <dt className="text-[#595959]">Perks</dt>
              <dd className="text-right">{wallet.benefits.join(", ")}</dd>
            </div>
          ) : null}
        </dl>
        <div className="mt-5 flex flex-wrap gap-2">
          <Button asChild>
            <Link to="/member/rewards">Rewards</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/member/trips">Trips</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/member/transactions">Points activity</Link>
          </Button>
          <Button
            type="button"
            variant="ghost"
            onClick={() => {
              void logout().then(() => navigate("/member/login", { replace: true }));
            }}
          >
            Sign out
          </Button>
        </div>
      </div>
    </PageWidth>
  );
}
